import axios, { AxiosInstance } from 'axios';

export const API_BASE_URL = '/api';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(config => {
  const authUser = sessionStorage.getItem('authUser');

  if (authUser) {
    const user = JSON.parse(authUser);

    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    if (user?.id) {
      config.headers['x-user-id'] = String(user.id);
    }
  }

  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('authUser');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
